import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PageTemplate from '../../../components/PageTemplate/PageTemplate';
import JobOffers from '../../../modals/components/layouts/business-dashboard/JobOffers/JobOffers';

export default function JobOffersPage() {
  const { t } = useTranslation();
  return (
    <Grid item lg={6} md={9} xs={12} sx={{ display: { xs: 'block' } }}>
      <PageTemplate title={t('job_offers')} content={<JobOffers />} />
    </Grid>
  );
}
